import {
  isDynamicImportError,
  reloadForStaleAssets,
} from "@/javascript/lib/stale_assets";

window.addEventListener("vite:preloadError", (event) => {
  if (reloadForStaleAssets()) event.preventDefault();
});

window.addEventListener("unhandledrejection", (event) => {
  if (isDynamicImportError(event.reason)) reloadForStaleAssets();
});
